import type { AfterViewInit } from '@angular/core';
import { Component, ElementRef, inject, input } from '@angular/core';
import type { OnyxColor } from '../../badges/interfaces';

@Component({
  selector: 'onyx-link',
  imports: [],
  templateUrl: './onyx-link.component.html',
  styleUrl: './onyx-link.component.scss',
})
export class OnyxLinkComponent implements AfterViewInit {
  private readonly elementRef = inject(ElementRef<HTMLElement>);

  public readonly color = input.required<OnyxColor | null>();
  public readonly font = input<`f-${string}`>('f-body-m');
  public readonly disabled = input(false);
  public readonly inactive = input(false);
  public readonly ellipsis = input(false);
  public readonly href = input<string>();
  public readonly target = input<'_blank' | '_self' | '_parent' | '_top'>(
    '_blank',
  );

  public ngAfterViewInit(): void {
    this.elementRef.nativeElement.tabIndex = -1;
  }
}
